import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { CoreTypes } from '../../../../../types';
import s from './BenefitsList.scss';

interface Props {
  coreType: CoreTypes;
  referer: string;
  isOpen: boolean;
}

const BenefitsList: React.FC<Props> = ({ coreType, referer, isOpen }) => {
  const { t } = useTranslation();

  // When coming from dreamup we show the AI section at the top
  const refererIsDreamUp = referer.startsWith(Url.dreamupLink());

  const isProPackage = [CoreTypes.CORE_PRO, CoreTypes.CORE_PRO_PLUS].includes(
    coreType
  );

  const top1benefit = isProPackage
    ? t('packagePicker.heroTable.benefits.mobile.sellAndPromote')
    : t('packagePicker.heroTable.benefits.mobile.customize');

  const renderDreamupBenefit = () => (
    <div className={s['benefits-item']}>
      {t(`packagePicker.heroTable.benefits.mobile.dreamUp`)}
      <div className={s['benefits-item-description']}>
        {t(
          `packagePicker.heroTable.benefits.mobile.${coreType}.dreamUpFeatures`
        )}
      </div>
    </div>
  );

  const renderFeeBenefits = () => (
    <div className={s['benefits-item']}>
      {t(`packagePicker.heroTable.benefits.mobile.platformFees`)}
      <div className={s['benefits-item-description']}>
        {t(
          `packagePicker.heroTable.benefits.mobile.${coreType}.platformFees.description.adoptabobbles`
        )}
      </div>
    </div>
  );

  return isOpen ? (
    <div className={s['benefits']}>
      {refererIsDreamUp && renderDreamupBenefit()}
      <div className={s['benefits-item']}>{top1benefit}</div>
      {isProPackage && renderFeeBenefits()}
      {isProPackage && (
        <div className={s['benefits-item']}>
          {t(`packagePicker.heroTable.benefits.mobile.customize`)}
        </div>
      )}
      <div className={s['benefits-item']}>
        {t(`packagePicker.heroTable.benefits.mobile.usernameChange`)}
      </div>
      <div className={s['benefits-item']}>
        {t(`packagePicker.heroTable.benefits.mobile.${coreType}.storage`)}
      </div>
      {!isProPackage && (
        <div className={s['benefits-item']}>
          {t('packagePicker.heroTable.benefits.mobile.sellAndPromote')}
        </div>
      )}
      {!isProPackage && renderFeeBenefits()}
      <div className={s['benefits-item']}>
        {t('packagePicker.heroTable.benefits.mobile.privateCollections')}
      </div>
      <div className={s['benefits-item']}>
        {t(`packagePicker.heroTable.benefits.mobile.insights`)}
      </div>

      {[CoreTypes.CORE_PRO, CoreTypes.CORE_PRO_PLUS].includes(coreType) && (
        <div className={s['benefits-item']}>
          {t(`packagePicker.heroTable.benefits.mobile.2FA`)}
        </div>
      )}
      {coreType === CoreTypes.CORE_PRO_PLUS && (
        <div className={s['benefits-item']}>
          {t(`packagePicker.heroTable.benefits.mobile.portfolioAndArtDomain`)}
          <div className={s['benefits-item-description']}>
            {t(
              `packagePicker.heroTable.benefits.mobile.portfolioAndArtDomain.description`
            )}
          </div>
        </div>
      )}

      {!refererIsDreamUp && renderDreamupBenefit()}

      <div className={s['foot-notes']}>
        <div className={s['desktop-info']}>
          {t(`packagePicker.heroTable.benefits.mobile.desktopInfo`)}
        </div>
        {t(`packagePicker.heroTable.benefits.mobile.thirdPartyProcessing`)}
      </div>
    </div>
  ) : (
    <div className={s['benefits-folded']}>
      <div className={s['benefits-item']}>{top1benefit}</div>
    </div>
  );
};
BenefitsList.displayName = 'BenefitsList';

export default BenefitsList;
